import { StateUtils } from '@spartacus/core';
import { PyStateUtils } from '../../../../../../core/state/utils/index';
import { News } from '../../model';
import { NEWS } from '../news-state';

export enum NewsActionTypes {
  LoadNews = '[News] Load News',
  LoadNewsFail = '[News] Load News fail',
  LoadNewsSuccess = '[News] Load News success',
}

export class LoadNews extends StateUtils.EntityLoadAction {
  readonly type = NewsActionTypes.LoadNews;

  constructor(public count: string) {
    super(NEWS, count);
  }
}

export class LoadNewsFail extends PyStateUtils.EntityFailAction {
  readonly type = NewsActionTypes.LoadNewsFail;

  constructor(public count: string, public payload?: any) {
    super(NEWS, count, payload);
  }
}

export class LoadNewsSuccess extends StateUtils.EntitySuccessAction {
  readonly type = NewsActionTypes.LoadNewsSuccess;

  constructor(public count: string, public payload: News[]) {
    super(NEWS, count, payload);
  }
}

export type NewsActions = LoadNews | LoadNewsFail | LoadNewsSuccess;
